/*
 * ef-mantel-3d.js — parametric rotatable 3D preview for the mantel-shelf configurator.
 * Models the real product: a matte-black OPEN-BACK steel channel (top + front + bottom +
 * two end caps, hollow at the wall side) with a slotted mounting lip along the top-back edge
 * — exactly how the shelf hangs on the wall cleat. True proportions, resizes live with L×H×D.
 * Billboarded LENGTH / HEIGHT / DEPTH labels remove the "which axis is which" confusion.
 * Drag to rotate around the model's own centre; bring it level and it STAYS (no auto-rotate).
 *
 * RENDER-ON-DEMAND: the canvas only re-renders when something changes (drag, dimension change,
 * resize). Idle = holds last frame → no continuous WebGL compositing, so native <select>
 * dropdowns don't flicker AND dimension changes show immediately.
 *
 * Progressive enhancement: if THREE/WebGL is unavailable, this bails and the SVG diagram stays.
 *
 * Public API (ef-pdp-mantels.js): window.EFMantel3D.setDims(Lin,Hin,Din) ; .setFinish() (no-op)
 */
(function () {
  var T = window.THREE;
  var mount = document.getElementById('efmShelf3D');
  if (!mount) return;
  function hasWebGL() {
    try { var c = document.createElement('canvas'); return !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl'))); }
    catch (e) { return false; }
  }
  if (!T || !hasWebGL()) { return; }

  var scene = new T.Scene();
  var camera = new T.PerspectiveCamera(32, 1, 0.1, 100);
  camera.position.set(3.0, 1.7, 4.2);
  camera.lookAt(0, 0, 0);

  var renderer = new T.WebGLRenderer({ antialias: true, alpha: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = T.PCFSoftShadowMap;
  if ('outputEncoding' in renderer) renderer.outputEncoding = T.sRGBEncoding;
  mount.appendChild(renderer.domElement);
  renderer.domElement.style.cssText = 'width:100%;height:100%;display:block;touch-action:pan-y;cursor:grab;';

  // ── Lighting — front key + strong back rim so the open hollow + slots read when rotated ──
  scene.add(new T.HemisphereLight(0xffffff, 0xcfc6b8, 0.62));
  var key = new T.DirectionalLight(0xfff6ea, 1.1);
  key.position.set(4, 6.5, 5);
  key.castShadow = true;
  key.shadow.mapSize.width = 1024; key.shadow.mapSize.height = 1024;
  key.shadow.camera.near = 0.5; key.shadow.camera.far = 30;
  key.shadow.camera.left = -8; key.shadow.camera.right = 8;
  key.shadow.camera.top = 8; key.shadow.camera.bottom = -8;
  key.shadow.bias = -0.0004;
  scene.add(key);
  var rim = new T.DirectionalLight(0xffffff, 0.85);
  rim.position.set(-4, 4, -6);                 // lights the back so the slotted lip is visible
  scene.add(rim);

  var pivot = new T.Group();
  scene.add(pivot);

  var material = new T.MeshStandardMaterial({ color: 0x202020, roughness: 0.52, metalness: 0.2 });
  var slotMat = new T.MeshStandardMaterial({ color: 0x000000, roughness: 1.0, metalness: 0.0 });

  // ── Shell = open-back channel + slotted mounting lip. Rebuilt on dims change. ──
  var shell = new T.Group();
  pivot.add(shell);
  var curW = 4, curH = 0.3, curD = 1;

  function buildShell() {
    while (shell.children.length) { var c = shell.children.pop(); if (c.geometry) c.geometry.dispose(); }
    var t = Math.max(Math.min(curH * 0.22, curD * 0.2, 0.045), 0.014);   // steel wall thickness
    function plate(w, h, d, x, y, z) {
      var m = new T.Mesh(new T.BoxGeometry(w, h, d), material);
      m.castShadow = true; m.position.set(x, y, z); shell.add(m);
    }
    plate(curW, t, curD, 0, curH / 2 - t / 2, 0);          // top
    plate(curW, t, curD, 0, -curH / 2 + t / 2, 0);         // bottom
    plate(curW, curH, t, 0, 0, curD / 2 - t / 2);          // front face
    plate(t, curH, curD, -curW / 2 + t / 2, 0, 0);         // left end cap
    plate(t, curH, curD, curW / 2 - t / 2, 0, 0);          // right end cap
    // back is OPEN (hollow, faces the wall)

    // back-top mounting lip (the slotted rail you hang on the wall cleat)
    var lipH = Math.min(curH * 0.55, t * 5);
    plate(curW, lipH, t, 0, curH / 2 - lipH / 2, -curD / 2 + t / 2);
    // row of mounting slots cut along that lip
    var lipZ = -curD / 2 + t - 0.002;
    var n = Math.max(6, Math.min(Math.round(curW / 0.11), 80));   // dense row of slots
    var slotW = (curW / n) * 0.6;
    var slotH = lipH * 0.42;
    var slotY = curH / 2 - lipH * 0.42;
    for (var i = 0; i < n; i++) {
      var s = new T.Mesh(new T.PlaneGeometry(slotW, slotH), slotMat);
      s.position.set(-curW / 2 + curW * (i + 0.5) / n, slotY, lipZ);
      s.rotation.y = Math.PI;                              // face outward from the back (-Z)
      shell.add(s);
    }
  }

  // ── Contact shadow ──
  var ground = new T.Mesh(new T.PlaneGeometry(60, 60), new T.ShadowMaterial({ opacity: 0.18 }));
  ground.rotation.x = -Math.PI / 2;
  ground.receiveShadow = true;
  scene.add(ground);

  // ── Billboarded dimension labels ──
  function makeLabel() {
    var c = document.createElement('canvas'); c.width = 320; c.height = 80;
    var tex = new T.CanvasTexture(c); tex.anisotropy = 4;
    var sp = new T.Sprite(new T.SpriteMaterial({ map: tex, transparent: true, depthTest: false, depthWrite: false }));
    sp.scale.set(1.5, 0.375, 1); pivot.add(sp);
    return { sp: sp, c: c, tex: tex };
  }
  function drawLabel(lab, title, val) {
    var ctx = lab.c.getContext('2d'); ctx.clearRect(0, 0, 320, 80);
    ctx.fillStyle = 'rgba(255,255,255,0.92)';
    var r = 16, w = 320, h = 80;
    ctx.beginPath();
    ctx.moveTo(r, 4); ctx.lineTo(w - r, 4); ctx.arcTo(w - 4, 4, w - 4, r, r);
    ctx.lineTo(w - 4, h - r); ctx.arcTo(w - 4, h - 4, w - r, h - 4, r);
    ctx.lineTo(r, h - 4); ctx.arcTo(4, h - 4, 4, h - r, r);
    ctx.lineTo(4, r); ctx.arcTo(4, 4, r, 4, r); ctx.closePath(); ctx.fill();
    ctx.fillStyle = '#8A6A43'; ctx.font = '700 22px Inter, Arial, sans-serif';
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText(title, 160, 28);
    ctx.fillStyle = '#1E1E1B'; ctx.font = '700 30px Inter, Arial, sans-serif'; ctx.fillText(val, 160, 56);
    lab.tex.needsUpdate = true;
  }
  var labLen = makeLabel(), labHgt = makeLabel(), labDep = makeLabel();

  function rebuild(Lin, Hin, Din) {
    var TARGET_LEN = 4.0, k = TARGET_LEN / Math.max(Lin, 1);
    curW = TARGET_LEN;
    curH = Math.max(Hin * k, 0.05);
    curD = Math.max(Din * k, 0.07);
    buildShell();
    ground.position.y = -curH / 2 - 0.02;
    labLen.sp.position.set(0, -curH / 2 - 0.42, curD / 2);
    labHgt.sp.position.set(curW / 2 + 0.55, 0, curD / 2);
    labDep.sp.position.set(curW / 2 + 0.2, -curH / 2 - 0.42, -curD / 2 - 0.05);
    drawLabel(labLen, 'LENGTH', Math.round(Lin) + '"');
    drawLabel(labHgt, 'HEIGHT', (Math.round(Hin * 10) / 10) + '"');
    drawLabel(labDep, 'DEPTH', (Math.round(Din * 10) / 10) + '"');
    frame(); requestRender();
  }

  function frame() {
    var vFOV = camera.fov * Math.PI / 180;
    var fitH = (curH + 1.4) / (2 * Math.tan(vFOV / 2));
    var fitW = (curW + 1.6) / (2 * Math.tan(vFOV / 2) * camera.aspect);
    var dist = (Math.max(fitH, fitW, 3.2) + curD * 0.5) * 0.87;   // ~15% larger model in frame
    camera.position.copy(new T.Vector3(0.5, 0.42, 0.86).normalize().multiplyScalar(dist));
    camera.lookAt(0, 0, 0);
  }

  rebuild(48, 5, 8);

  // ── Drag rotation (around centre); levels out and stays ──
  var rotY = -0.6, rotX = 0.2, dragging = false, lastX = 0, lastY = 0;
  function px(e) { return e.touches ? e.touches[0].clientX : e.clientX; }
  function py(e) { return e.touches ? e.touches[0].clientY : e.clientY; }
  function onDown(e) { dragging = true; lastX = px(e); lastY = py(e); renderer.domElement.style.cursor = 'grabbing'; }
  function onMove(e) {
    if (!dragging) return;
    var x = px(e), y = py(e);
    rotY += (x - lastX) * 0.01;
    rotX += (y - lastY) * 0.008;
    rotX = Math.max(-0.05, Math.min(1.2, rotX));
    lastX = x; lastY = y; requestRender();
    if (e.cancelable && e.touches) e.preventDefault();
  }
  function onUp() { dragging = false; renderer.domElement.style.cursor = 'grab'; }
  renderer.domElement.addEventListener('mousedown', onDown);
  window.addEventListener('mousemove', onMove);
  window.addEventListener('mouseup', onUp);
  renderer.domElement.addEventListener('touchstart', onDown, { passive: true });
  renderer.domElement.addEventListener('touchmove', onMove, { passive: false });
  renderer.domElement.addEventListener('touchend', onUp);

  function resize() {
    var w = mount.clientWidth || 440, h = mount.clientHeight || 280;
    renderer.setSize(w, h, false);
    camera.aspect = w / h; camera.updateProjectionMatrix();
    frame(); requestRender();
  }
  if (window.ResizeObserver) { new ResizeObserver(resize).observe(mount); } else { window.addEventListener('resize', resize); }
  resize();

  // ── Render on demand ──
  var needsRender = true;
  function requestRender() { needsRender = true; }
  function loop() {
    requestAnimationFrame(loop);
    if (document.hidden || !needsRender) return;
    pivot.rotation.y = rotY; pivot.rotation.x = rotX;
    renderer.render(scene, camera);
    if (!dragging) needsRender = false;
  }
  loop();

  mount.classList.add('is-active');
  var svg = document.getElementById('efmShelfSvg');
  if (svg && svg.parentNode) svg.parentNode.classList.add('efm-svg-hidden');

  window.EFMantel3D = {
    setDims: function (L, H, D) { rebuild(+L || 48, +H || 5, +D || 8); },
    setFinish: function () { /* colour preview removed — matte black fixed (2026-06-25) */ }
  };
})();
